export enum ProjectVisibilityEnum {
    /// <summary>Default, this project Power BI report is not visible yet</summary>
    NotPublished = 0,
    /// <summary>Published, but only to the preview page, to allow review before final publish to customer</summary>
    InPreview = 1,
    /// <summary>Published and visible to the customer portal</summary>
    PublishedToCustomer = 2
}
